import React, { useState } from 'react'
import { useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AlertContext from '../../../../Context/Alert/AlertContext'
import { BaseURL } from '../../../../Files/BaseURL'
import { useEffect } from 'react'

const BoostAdd = ({ setBoostAddSet }) => {
    const navigate = useNavigate()
    const { id } = useParams();

    const [Step, setStep] = useState(1)
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [BoostPlan, setBoostPlan] = useState(null)
    const [paymentPlans, setPaymentPlans] = useState([])
    const { showAlert } = useContext(AlertContext)

    const payPaypal = async (type) => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/addSystem/addPayment/add-payment/${id}/${BoostPlan}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            },
            body: JSON.stringify({
                type: type
            })
        });
        if (!res.ok) {
            showAlert('Error processing PayPal payment:', 'danger');
            setLoading(false);
            return;
        }
        const result = await res.json();
        if (result.redirect_url) {
            window.location.href = result.redirect_url;
        } else {
            showAlert('Error processing PayPal payment', 'danger');
        }
    };

    const userInfo = async () => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/payment/account/pay-info`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            }
        });
        return await res.json();
    };

    const fetchDetails = async () => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await fetch(`${BaseURL}/api/addSystem/info/list`, {
                method: "GET",
                headers: {
                    "auth-token": authToken
                }
            })
            const responseJSON = await response.json();
            if (response.ok) {
                setPaymentPlans(responseJSON)
            }
        } catch (e) {
            showAlert("Error fetching details", 'danger')
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const res = await userInfo();
            setInfo(res);
        }
        fetchData()
        fetchDetails()
    }, [])



    return (
        <div className={`top-0 left-0 w-[100vw] h-[100vh] fixed z-[99999999999999] font-pop `}>
            <div className="absolute bg-black/50 block w-[100vw] h-[100vh] z-30" onClick={() => { setBoostAddSet(false) }}></div>
            {Step == 2 ?
                <div className='py-4 px-6 bg-white w-fit max-h-[70vh] mt-16 h-fit rounded-xl  relative z-40 m-auto'>
                    <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">Boost Ad</h2>
                    <p className="text-gray-600 mb-6 text-sm md:text-base max-w-sm">Choose your payment method</p>
                    <div className="flex flex-col font-pop gap-4">
                        {info.AttachedPaypal && (
                            <div 
                                className={`flex flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer ${loading && "opacity-50"}`}
                                onClick={() => { 
                                    if(!loading){
                                        payPaypal() 
                                    }
                                }}
                            >
                                <img src="../../../../Assets/Accounts/Paypal.png" alt="" className='w-6 md:w-8 h-6 md:h-8' />
                                <p className='text-base md:text-lg font-medium'>
                                    PayPal account ({info.AttachedPaypal.Email.substring(0, 4)} ****)
                                </p>
                            </div>
                        )}
                        {info.AttachedCard && (
                            <div 
                                className={`flex flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer ${loading && "opacity-50"}`}
                                onClick={() => { 
                                    if(!loading){
                                        payPaypal(card) 
                                    }
                                }}
                            >
                                <img src="../../../../Assets/Accounts/card.png" alt="" className='w-6 md:w-8 h-6 md:h-8' />
                                <p className='text-base md:text-lg font-medium'>Credit card (**** {info.AttachedCard.LastDigits})</p>
                            </div>
                        )}
                    </div>
                </div>
                :
                <div className='py-4 px-6 bg-white w-[95%] md:w-[50%] xl:w-[30%] max-h-[70vh] overflow-y-auto mt-16 h-fit rounded-xl  relative z-40 m-auto'>
                    <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">Boost Ad</h2>
                    <p className="text-gray-600 mb-6 text-sm md:text-base max-w-sm">Choose timerange</p>
                    <div className="flex flex-col font-pop gap-4">
                        {paymentPlans?.map((item, index) => (
                            <div
                                key={index}
                                className={`flex font-medium flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer ${BoostPlan == item._id && "border-primarygreen bg-primarygreen/30"}`}
                                onClick={() => { setBoostPlan(item._id) }}
                            >
                                <h3>{item?.time} {item?.type}</h3>
                                <p className='text-lg'>${item?.price}</p>
                            </div>
                        ))}
                    </div>
                    <div
                        className="bg-primarygreen text-lg font-semibold my-4  text-center w-full border-2 border-primarygreen rounded-full font-pop text-white py-2 px-5 cursor-pointer"
                        onClick={() => {
                            if (BoostPlan) {
                                setStep(2)
                            }
                        }}
                    >
                        Continue
                    </div>
                </div>
            }
        </div>
    )
}

export default BoostAdd